/*
 * @Descripttion:
 * @Date: 2024-08-06 10:12:42
 */
import http from '@/utils/http/axios';
import type { ContinuousLabourList, AverageLabourList } from './types';

enum Api {
  continuousLabourList = '/front-end/asp-labour-order/continuousLabourList', // 连续劳务列表
  averageLabourList = '/front-end/asp-labour-order/averageLabourList', // 一般劳务列表

  continuousLabourExport = '/front-end/asp-labour-order-export/continuousLabourExport', // 连续劳务-导出
  averageLabourExport = '/front-end/asp-labour-order-export/averageLabourExport' // 一般劳务-导出
}

export const continuousLabourList: ContinuousLabourList = params => {
  return http.request({
    url: Api.continuousLabourList,
    method: 'POST',
    params
  });
};
export const averageLabourList: AverageLabourList = params => {
  return http.request({
    url: Api.averageLabourList,
    method: 'POST',
    params
  });
};

export const continuousLabourExport = params =>
  http.download(
    {
      url: Api.continuousLabourExport,
      method: 'POST',
      params
    },
    {
      isShowSuccessMessage: true
    }
  );

export const averageLabourExport = params =>
  http.download(
    {
      url: Api.averageLabourExport,
      method: 'POST',
      params
    },
    {
      isShowSuccessMessage: true
    }
  );
